/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FEATURE_FLAG = "ALTERNATE_OLDEST_FIRST_VIEW" | "AVATARS" | "DEFAULT_QA_STORY_MODE" | "DISABLE_WARN_USER_OF_TOXIC_COMMENT" | "DISCUSSIONS" | "ENABLE_AMP" | "ENABLE_QA" | "ENABLE_RATINGS_AND_REVIEWS" | "EXTERNAL_MEDIA" | "FLATTEN_REPLIES" | "NEW_COMMENT_COUNT" | "READ_MORE_NEW_TAB" | "REDUCED_SECURITY_MODE" | "RTE_SARCASM" | "SECTIONS" | "SITE_MODERATOR" | "VIEWER_COUNT" | "%future added value";
export type UserBanPopoverContainer_settings = {
    readonly featureFlags: ReadonlyArray<FEATURE_FLAG>;
    readonly " $refType": "UserBanPopoverContainer_settings";
};
export type UserBanPopoverContainer_settings$data = UserBanPopoverContainer_settings;
export type UserBanPopoverContainer_settings$key = {
    readonly " $data"?: UserBanPopoverContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBanPopoverContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBanPopoverContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "featureFlags",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'b294d89214b58407e08aaf7a5104b376';
export default node;
